import WizardModalWrapperLayout from 'Views/Page/Content/Modal/Layouts/WizardModalWrapperLayout';
import React from 'react';
import Content from 'Views/Page/Content/Templates/BigPickListTemplate/Content';

const Layout = () => (
  <WizardModalWrapperLayout>
    <Content />
  </WizardModalWrapperLayout>
);

export default Layout;
